module.exports = __webpack_public_path__ + "c3c886b5fef9a3ee6efa8c00160288cb.png";